import MentorFeedback from '../components/mentorResume/MentorFeedback';

const MentorFeedbackPage = () => {
    return (
        <>
            <MentorFeedback />
        </>
    );
};

export default MentorFeedbackPage;
